import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVeiligLegitiem = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M32 10H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2"
    />
    <path
      fill="#00C5F2"
      d="M12.5 21.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M8 26a4.49 4.49 0 0 1 4.5-4.5A4.49 4.49 0 0 1 17 26z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M10.36 17.75a2.14 2.14 0 1 0 4.28 0h1a3.14 3.14 0 1 1-6.28 0zM32 14.5H20v-1h12zM32 17.5H20v-1h12z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M23.41 22.14V20.3a2.458 2.458 0 0 1 3.433-2.414A2.46 2.46 0 0 1 28.32 20.3v1.84h-7.9a.69.69 0 0 0-.7.69v9.68a.69.69 0 0 0 .7.69h10.9a.69.69 0 0 0 .69-.69v-9.68a.69.69 0 0 0-.69-.69h-1.16V20.3a4.302 4.302 0 0 0-7.34-3.04 4.3 4.3 0 0 0-1.26 3.04v1.84"
    />
    <path
      fill="#85E3F9"
      d="M27.7 26.44a1.85 1.85 0 1 0-2.63 1.66l-.44 2.64h2.46l-.44-2.64a1.82 1.82 0 0 0 1.05-1.66"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVeiligLegitiem);

export default ForwardRef;
